import { t } from "../i18n";
import { SvgIcon } from "./SvgIcon";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const defaultProps = {
  className: '',
  viewBox: '-2 -2 18 18'
};
export function CloseIconThin(props) {
  const iconCssClasses = `ds-c-icon--close ds-c-icon--close-thin ${props.className || ''}`;
  return /*#__PURE__*/_jsx(SvgIcon, {
    title: t('icons.close'),
    ...defaultProps,
    ...props,
    className: iconCssClasses,
    children: /*#__PURE__*/_jsx("path", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: "2",
      d: "M0 13.0332964L13.0332964 0M13.0332964 13.0332964L0 0"
    })
  });
}